import React, { useEffect, useState, useRef } from "react";
import "./DispatchSummary.css";
import {
  Grid,
  Container,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  TableHead,
  Modal,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Button/button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import DeleteIcon from "@mui/icons-material/Delete";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { images } from "../../config/images";
import SearchIcon from "@mui/icons-material/Search";
import { userFootFallTracking } from "../FootFallReport/services";

const DispatchSummary = () => {
  const navigate = useNavigate();

  const data = [
    {
      srNo: "01",
      uid: "I0000001",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010107",
    },
    {
      srNo: "02",
      uid: "I0000003",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010108",
    },
    {
      srNo: "03",
      uid: "I0000005",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010109",
    },
    {
      srNo: "04",
      uid: "I0000007",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010110",
    },
    {
      srNo: "05",
      uid: "I0000009",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010111",
    },
    {
      srNo: "06",
      uid: "I0000006",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010112",
    },
    {
      srNo: "07",
      uid: "I0000008",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010113",
    },
    {
      srNo: "08",
      uid: "I0000010",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010114",
    },
    {
      srNo: "09",
      uid: "I0000012",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010115",
    },
    {
      srNo: "10",
      uid: "I0000015",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010116",
    },
    {
      srNo: "11",
      uid: "I0000016",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010117",
    },
    {
      srNo: "12",
      uid: "I0000019",
      description: "CPVC Pipe 1/2' inch pipes for domestic sales",
      orderId: "DEA0010118",
    },
  ];

  const initiallValue = {
    sr_no: "",
    uid: "",
    product_description: "",
    order_id: "",
  };
  const [searchText, setSearchText] = useState(initiallValue);
  const [getHistoryData, setGetHistoryData] = useState([]);
  const [Count, setCount] = useState("");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isDeletePopupOpen, setDeletePopup] = useState();

  const handleSearchData = async (e) => {
    const { name, value } = e.target;
    setSearchText({ ...searchText, [name]: value });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleCancelDelete = () => {
    setDeletePopup(false); // Close popup without deleting
  };

  useEffect(() => {
    let intervalId = null;

    const callUserFootFallTracking = () => {
      const moduleList = JSON.parse(localStorage.getItem("moduleList"));
      if (moduleList) {
        const module = moduleList.find((m) => m.name === "Dispatch Summary");
        if (module) {
          const params = { module_id: module.id };
          try {
            userFootFallTracking(params);
          } catch (error) {
            console.error("Error calling userFootFallTracking:", error);
          }
        }
      }
    };

    const startTracking = () => {
      if (!intervalId) {
        console.log("▶️ Start API interval");
        callUserFootFallTracking(); // call immediately
        intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
      }
    };

    const stopTracking = () => {
      if (intervalId) {
        console.log("⏹ Stop API interval");
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopTracking(); // stop when tab hidden/minimized
      } else {
        startTracking(); // resume when tab active
      }
    };

    // Setup listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Start tracking immediately if tab is visible
    if (!document.hidden) {
      startTracking();
    }

    return () => {
      stopTracking();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  return (
    <>
      <div className="containerWrap">
        <Container maxWidth="xxl">
          <div className="packingHeader-wrap">
            <div className="packingTitle-wrap">
              <KeyboardBackspaceIcon
                onClick={() => navigate("/dashboard")}
                className="backArrow"
              />
              <Typography
                variant="h5"
                className="packingTitle"
                gutterBottom
                onClick={() => navigate("/dashboard")}
              >
                Dispatch Summary
              </Typography>
            </div>
            <div className="dispatchSummary-print-section">
              <Button
                title="print preview"
                classname={"border-btn"}
                onClick={() => navigate("/dispatch-print-preview")}
                style={{
                  width: "120px",
                  backgroundColor: "white",
                  border: "1px solid #475467",
                  color: "#3C4856",
                }}
              />
              <Button
                title="print history"
                classname={"border-btn"}
                onClick={() => navigate("/dispatch-print-history")}
                style={{
                  width: "120px",
                  backgroundColor: "white",
                  border: "1px solid #475467",
                  color: "#3C4856",
                }}
              />
              <img src={images.settingIcon} />
              <img src={images.addIcon} />
            </div>
          </div>
          <div className="dispatchSummaryTable-top">
            <div className="dispatchSummaryTable-top-box">
              <div>
                <span style={{ fontWeight: 500 }}> Box No: </span>
                B10
              </div>
              <div className="disptachSummaryTable-top-box-customerName">
                <div style={{ fontWeight: 500 }}> Customer Name: </div>
                <Box style={{ width: "330px" }}>
                  <select
                    className="dispatch-form-input-class"
                    id="selectedClass"
                    defaultValue="all"
                    // value={selectedPlantId}
                    // onChange={(event) =>
                    //     setselectedPlantId(event.target.value)
                    // }
                    required
                  >
                    <option value={1}> JSW Steel Limited </option>
                    <option value={2}> Ideal Electrify Shop LLP</option>
                    <option value={3}> Ceylon Electricity Board </option>
                    <option value={4}> Astral </option>
                  </select>
                </Box>
              </div>
            </div>
            <div className="dispatchSummaryTable-top-order">
              <div style={{ fontWeight: 500 }}> Order Id: </div>
              <Box className="dispatchSummaryTable-top-orderBox">
                DEA0010107
              </Box>
              <Box className="dispatchSummaryTable-top-orderBox">
                DEA0010108
              </Box>
              <Box className="dispatchSummaryTable-top-orderBox">
                DEA0010109
              </Box>
            </div>
          </div>
          <div className="dispatchSummaryTable">
            <Table>
              <TableHead className="dispatchTable-head">
                <TableRow className="dispatchTable-headRow">
                  <TableCell
                    className="dispatchTable-headRow-cell"
                    style={{ width: "10px" }}
                  >
                    SR.No
                  </TableCell>
                  <TableCell
                    className="dispatchTable-headRow-cell"
                    style={{ width: "20px" }}
                  >
                    UID
                  </TableCell>
                  <TableCell className="dispatchTable-headRow-cell">
                    Product Description
                  </TableCell>
                  <TableCell
                    className="dispatchTable-headRow-cell"
                    style={{ width: "20px" }}
                  >
                    Order Id
                  </TableCell>
                  <TableCell
                    className="dispatchTable-headRow-cell"
                    style={{ width: "10px" }}
                  ></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="SR. No"
                      name="product__product_name"
                      value={searchText.sr_no}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="UID"
                      name="uid"
                      value={searchText.uid}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Product Description"
                      name="product_description"
                      value={searchText.product_description}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Order Id"
                      name="order_id"
                      value={searchText.order_id}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="dispatchTable-body">
                {data.map((row, index) => (
                  <TableRow className="dispatchTable-bodyRow" key={index}>
                    <TableCell className="dispatchTable-bodyRow-cell">
                      {row.srNo}
                    </TableCell>
                    <TableCell className="dispatchTable-bodyRow-cell">
                      {row.uid}
                    </TableCell>
                    <TableCell className="dispatchTable-bodyRow-cell">
                      {" "}
                      {row.description}
                    </TableCell>
                    <TableCell className="dispatchTable-bodyRow-cell">
                      {row.orderId}{" "}
                    </TableCell>
                    <TableCell className="dispatchTable-bodyRow-cell">
                      <img
                        src={images.deleteIcon}
                        onClick={() => {
                          setDeletePopup(!isDeletePopupOpen);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            className="table-pagination"
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={Count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <Modal open={isDeletePopupOpen}>
            {/* <Modal > */}
            <div className="popup-container" style={{ width: "343px" }}>
              <Typography variant="h6">
                Are You Sure <br />
                You Want To Delete?
              </Typography>
              <div className="popup-buttons">
                <Button
                  classname="custom-button"
                  title="Yes"
                  // onClick={handleConfirmPrint}
                  style={{ marginRight: "8px" }}
                />
                <Button
                  classname="border-btn"
                  color="secondary"
                  title="No"
                  onClick={() => handleCancelDelete()}
                  style={{
                    border: "none",
                    backgroundColor: "#A9B0BD",
                  }}
                />
              </div>
            </div>
          </Modal>
        </Container>
      </div>
    </>
  );
};

export default DispatchSummary;
